// Exception: HOC that proxy down props
/* eslint-disable react/jsx-props-no-spreading */

import { FC, SVGProps } from 'react';

import classes from './Image.module.scss';

const WiringImage: FC<SVGProps<SVGSVGElement>> = props => (
  // View box is shifted to the left, so the chip is exactly in the center.
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-40 0 2000 2000" xmlSpace="preserve" {...props}>
    <path
      className={classes.st5}
      d="M1673.42 1340.4 960.51 1752l-709.15-409.43 712.91-411.6 709.15 409.43z"
    />
    <path className={classes.st0} d="m864.96 1696.58 15.38-8.88m-12.95 10.28 68.37-39.47v-2.89" />
    <path className={classes.st0} d="m869.82 1699.38 121.62-70.06v-5.77" />
    <path className={classes.st0} d="m872.24 1700.78 174.34-100.65v-8.65" />
    <path className={classes.st0} d="M874.67 1702.18 1102 1570.94v-11.05" />
    <path
      className={classes.st0}
      d="m877.1 1703.58 280.31-161.83v-14.41m-354.48 133.42 15.38-8.88m-12.95 10.28 68.37-39.47v-2.88"
    />
    <path className={classes.st0} d="m807.79 1663.57 121.35-70.07.27-5.76" />
    <path className={classes.st0} d="m810.21 1664.97 174.34-100.66v-8.64" />
    <path className={classes.st0} d="m812.64 1666.37 227.33-131.25v-11.04" />
    <path
      className={classes.st0}
      d="m815.07 1667.77 280.31-161.84v-14.4M740.64 1624.8l15.39-8.88m-12.96 10.28 68.37-39.47v-2.88"
    />
    <path className={classes.st0} d="m745.5 1627.6 121.35-70.06v-5.76" />
    <path className={classes.st0} d="m747.93 1629.01 174.33-100.66v-8.64" />
    <path className={classes.st0} d="m750.35 1630.41 227.33-131.25v-11.05" />
    <path
      className={classes.st0}
      d="m752.78 1631.81 280.31-161.84v-14.41m-355.06 133.09 15.39-8.88m-12.96 10.29 68.37-39.48v-2.88"
    />
    <path className={classes.st0} d="m682.89 1591.46 121.35-70.07v-5.76" />
    <path className={classes.st0} d="m685.32 1592.86 174.34-100.66v-8.64" />
    <path className={classes.st0} d="m687.74 1594.26 227.33-131.25v-11.04" />
    <path
      className={classes.st0}
      d="m690.17 1595.66 280.31-161.83v-14.41M615.9 1552.78l15.38-8.88m-12.95 10.28 68.37-39.47v-2.88"
    />
    <path className={classes.st0} d="m620.76 1555.58 121.35-70.06v-5.76" />
    <path className={classes.st0} d="m623.18 1556.99 174.34-100.66v-8.64" />
    <path className={classes.st0} d="m625.61 1558.39 227.33-131.25v-11.04" />
    <path
      className={classes.st0}
      d="m628.04 1559.79 280.31-161.84v-14.41M927.79 1732.85l15.39-8.88M930.22 1734.25l68.37-39.47M932.65 1735.66l121.35-70.07v-5.76"
    />
    <path className={classes.st0} d="m935.08 1737.06 174.34-100.66v-8.64" />
    <path className={classes.st0} d="m937.5 1738.46 227.33-131.25v-11.04" />
    <path
      className={classes.st0}
      d="m939.93 1739.86 280.31-161.84v-14.4m434.86-233.86-348.68 201.31-29.95.47M1592.27 1293.49l-348.68 201.31-29.95.47m316.59-237.6-348.67 201.31-29.95.47m316.34-237.74-348.68 201.31-29.95.47m316.02-237.93-348.68 201.31-29.95.47m316.5-237.65L994.53 1351l-29.95.47m316.41-237.7-348.68 201.31-29.94.47m316.4-237.7-348.68 201.3-29.95.48m317.22-237.24L808.68 1243.7l-29.95.47m-225.04 272.69 15.38-8.88m-12.95 10.28 68.36-39.47v-2.88"
    />
    <path className={classes.st0} d="m558.54 1519.67 121.36-70.07v-5.76" />
    <path className={classes.st0} d="m560.97 1521.07 174.34-100.66v-8.64" />
    <path className={classes.st0} d="m563.4 1522.47 227.32-131.25v-11.04" />
    <path
      className={classes.st0}
      d="m565.83 1523.87 280.31-161.84v-14.41m-354.68 133.32 15.38-8.89m-12.95 10.29 68.37-39.47v-2.89"
    />
    <path className={classes.st0} d="m496.32 1483.74 121.35-70.06v-5.77" />
    <path className={classes.st0} d="m498.74 1485.14 174.34-100.65v-8.65" />
    <path className={classes.st0} d="M501.17 1486.54 728.5 1355.3v-11.05" />
    <path
      className={classes.st0}
      d="m503.6 1487.94 280.31-161.83v-14.41m-353.85 133.78 15.38-8.88m-12.96 10.29 68.37-39.48v-2.88"
    />
    <path className={classes.st0} d="m434.91 1448.29 121.35-70.07v-5.76" />
    <path className={classes.st0} d="m437.34 1449.69 174.34-100.66v-8.64" />
    <path className={classes.st0} d="m439.77 1451.09 227.32-131.25v-11.04" />
    <path
      className={classes.st0}
      d="m442.19 1452.49 280.31-161.83v-14.41m920.46 46.5-83.75 48.36-4.99.08"
    />
    <path className={classes.st0} d="m1645.39 1324.16-136.74 78.94-9.98.16" />
    <path className={classes.st0} d="m1647.82 1325.56-189.73 109.53-14.97.24" />
    <path className={classes.st0} d="m1650.24 1326.96-242.7 140.13-19.14.3" />
    <path
      className={classes.st0}
      d="m1652.67 1328.36-295.69 170.72-24.96.39M1580.13 1286.48l-83.75 48.35-4.99.08"
    />
    <path className={classes.st0} d="m1582.56 1287.88-136.74 78.95-9.98.15" />
    <path className={classes.st0} d="m1584.98 1289.28-189.72 109.54-14.97.23" />
    <path className={classes.st0} d="m1587.41 1290.68-242.71 140.13-19.13.3" />
    <path
      className={classes.st0}
      d="m1589.84 1292.08-295.69 170.72-24.96.4m248.91-212.54-83.75 48.36-5 .08"
    />
    <path className={classes.st0} d="m1520.52 1252.07-136.73 78.94-9.98.16" />
    <path className={classes.st0} d="M1522.95 1253.47 1333.23 1363l-14.97.24" />
    <path className={classes.st0} d="M1525.38 1254.87 1282.67 1395l-19.13.3" />
    <path
      className={classes.st0}
      d="m1527.81 1256.27-295.7 170.72-24.95.39m248.65-212.68-83.75 48.36-4.99.08"
    />
    <path className={classes.st0} d="m1458.24 1216.1-136.74 78.95-9.98.16" />
    <path className={classes.st0} d="m1460.66 1217.51-189.72 109.53-14.97.24" />
    <path className={classes.st0} d="m1463.09 1218.91-242.71 140.12-19.13.31" />
    <path
      className={classes.st0}
      d="m1465.52 1220.31-295.69 170.72-24.96.39m248.33-212.86-83.75 48.35-4.99.08"
    />
    <path className={classes.st0} d="m1395.63 1179.96-136.74 78.94-9.98.16" />
    <path className={classes.st0} d="m1398.06 1181.36-189.73 109.53-14.97.24" />
    <path className={classes.st0} d="m1400.48 1182.76-242.7 140.13-19.14.3" />
    <path
      className={classes.st0}
      d="m1402.91 1184.16-295.69 170.72-24.96.39m248.81-212.59-83.75 48.36-5 .08"
    />
    <path className={classes.st0} d="m1333.49 1144.08-136.73 78.95-9.98.16" />
    <path className={classes.st0} d="m1335.92 1145.49-189.72 109.53-14.97.24" />
    <path className={classes.st0} d="m1338.35 1146.89-242.71 140.13-19.13.3" />
    <path
      className={classes.st0}
      d="m1340.78 1148.29-295.7 170.72-24.95.39m248.72-212.64-83.75 48.36-4.99.08"
    />
    <path className={classes.st0} d="m1271.28 1108.17-136.73 78.94-9.99.16" />
    <path className={classes.st0} d="m1273.71 1109.57-189.72 109.53-14.98.24" />
    <path className={classes.st0} d="m1276.14 1110.97-242.71 140.13-19.13.3" />
    <path
      className={classes.st0}
      d="m1278.56 1112.37-295.69 170.72-24.95.39m248.71-212.64-83.75 48.35-5 .08"
    />
    <path className={classes.st0} d="m1209.05 1072.24-136.73 78.94-9.98.16" />
    <path className={classes.st0} d="m1211.48 1073.64-189.72 109.54-14.97.23" />
    <path className={classes.st0} d="M1213.91 1075.04 971.2 1215.17l-19.13.3" />
    <path
      className={classes.st0}
      d="m1216.34 1076.44-295.7 170.72-24.95.4m249.53-212.17-83.75 48.35-4.99.08"
    />
    <path className={classes.st0} d="m1147.65 1036.79-136.74 78.94-9.98.16" />
    <path className={classes.st0} d="m1150.08 1038.19-189.72 109.53-14.98.24" />
    <path className={classes.st0} d="M1152.51 1039.59 909.8 1179.72l-19.14.3" />
    <path
      className={classes.st0}
      d="m1154.93 1040.99-295.69 170.72-24.96.39m-464.73 198.45 89.74-51.8v-2.89"
    />
    <path className={classes.st0} d="m371.98 1411.96 142.72-82.4v-5.77" />
    <path className={classes.st0} d="m374.41 1413.36 195.7-112.99v-8.65" />
    <path className={classes.st0} d="m376.84 1414.76 248.69-143.58v-11.53" />
    <path className={classes.st0} d="m379.26 1416.16 301.68-174.17.68-14.41" />
    <path
      className={classes.st0}
      d="m381.69 1417.56 354.66-204.76v-17.29m-428.68 179.32 89.74-51.81v-2.88"
    />
    <path className={classes.st0} d="m310.1 1376.23 142.72-82.4v-5.76" />
    <path className={classes.st0} d="m312.53 1377.63 195.7-112.99v-8.65" />
    <path className={classes.st0} d="m314.96 1379.03 248.69-143.58v-11.53" />
    <path className={classes.st0} d="m317.38 1380.43 301.68-174.17.68-14.41" />
    <path
      className={classes.st0}
      d="m319.81 1381.83 354.66-204.76v-17.29m407.82-160.73-6.83 3.95-4.99.08m14.25-2.62-59.82 34.53-9.98.16"
    />
    <path className={classes.st0} d="m1087.15 1001.86-112.81 65.13-14.97.23" />
    <path className={classes.st0} d="m1089.58 1003.26-165.8 95.72-19.96.31" />
    <path className={classes.st0} d="m1092 1004.66-218.77 126.31-24.96.39" />
    <path
      className={classes.st0}
      d="m1094.43 1006.06-271.76 156.9-29.95.48m227.69-200.11-6.83 3.94-5 .08m14.26-2.62-59.82 34.54-9.98.15"
    />
    <path className={classes.st0} d="m1025.27 966.13-112.81 65.13-14.97.24" />
    <path className={classes.st0} d="m1027.7 967.53-165.8 95.72-19.96.32" />
    <path className={classes.st0} d="m1030.12 968.93-218.78 126.31-24.95.4" />
    <path className={classes.st0} d="m1032.55 970.33-271.76 156.91-29.95.47" />
  </svg>
);

export default WiringImage;
